import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { MetaDataQuery, MetadataYamlAddress } from "../../types/graphql-types"
import Phone from "../assets/icons/zondicons/phone.svg"
import Envelope from "../assets/icons/zondicons/envelope.svg"

const Footer: React.FC<void> = () => {
  const data: MetaDataQuery = useStaticQuery(graphql`
    query MetaData {
      metadataYaml(address: {}, id: { eq: "main" }) {
        address {
          building
          city
          faculty
          name
          room
          street
          telephone
          university
          zipcode
          email
        }
      }
    }
  `).metadataYaml
  let address: MetadataYamlAddress = data?.address
  return (
    <div
      class="bg-fb12-blue-400 z-40"
      style={{ boxShadow: "15px 0 0 0 rgba(0,0,0,0.1)" }}
    >
      <footer>
        <div class="leading-relaxed mx-auto max-w-4xl md:max-w-6xl pt-12 pl-4 text-fb12-blue-100 md:flex md:flex-wrap text-lg">
          <div class="w-full md:w-2/5 pb-4 md:pb-12 pr-4">
            <div>{address.name}</div>
            <div class="text-xl font-semibold text-white">
              {address.faculty}
            </div>
            <div>{address.university}</div>
            <div>{address.street}</div>
            <div>
              {address.zipcode} {address.city}
            </div>
            <div>
              {address.building} ({address.room})
            </div>
          </div>
          <div class="w-full md:w-2/5 pb-12 pr-4">
            <div class="flex items-start items-center">
              <div class="fill-current ">
                <Phone class="h-4 mr-4" />
              </div>

              <div>{address.telephone}</div>
            </div>
            <div class="flex items-start">
              <div class="fill-current h-7 flex items-center">
                <Envelope class="h-4 mr-4" />
              </div>
              <div>
                <div>{address.email}</div>
                <div>
                  Für die vollständige E-Mail-Adresse fügen Sie bitte{" "}
                  <span class="inline font-semibold text-white">
                    .uni-marburg.de
                  </span>{" "}
                  an.
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
